import { useRef } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import "../Styles/main.css";
import AnchorLink from 'react-anchor-link-smooth-scroll';

function Navbar() {
	const navRef = useRef();

	const showNavbar = () => {
		navRef.current.classList.toggle("responsive_nav");
	};

	return (
		<header>
			 <img className='imagem_topMenu' src='../../assets/logoMy1.png' style={{ }} alt="" />
           <img className='imagem_top25Menu' src='../../assets/logoMy2.png' style={{ }} alt="" />
			<nav ref={navRef}>
			<AnchorLink href='#home' >  
			<a onClick={showNavbar}>Sobre Mim</a>
          </AnchorLink> 
		  <AnchorLink href='#Meio1' >  
			<a onClick={showNavbar}>Especialidade</a>
          </AnchorLink> 
		  <AnchorLink href='#Meio4' >  
			<a onClick={showNavbar}>Contato</a>
          </AnchorLink>
		  <AnchorLink href='#Meio3' >  
			<a onClick={showNavbar}>Depoimentos</a>
          </AnchorLink> 
		  <AnchorLink href='#Meio2' >  
			<a onClick={showNavbar}>Você Sabia?</a>
          </AnchorLink>
		   
				
			
				<button
					className="nav-btn nav-close-btn"
					onClick={showNavbar}>
					<FaTimes />
				</button>
			</nav>
			<button className="nav-btn" onClick={showNavbar}>
				<FaBars />
			</button>
		</header>
	);
}

export default Navbar;
